module.exports = __webpack_public_path__ + "img/skills-hammerdin-3.dfa761fc.png";